import { useLocation } from 'react-router-dom'
import PreservedLink from './PreservedLink'

const Logo = ({ variant = 'default' }) => {
  const location = useLocation()
  const logoSrc =
    variant === 'footer' ? '/Logo/claims1-white-logo.png' : '/Logo/Claims1.png'

  const handleLogoClick = e => {
    // If already on home page, scroll to top instead of navigating
    if (location.pathname === '/') {
      e.preventDefault()
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    }
  }

  return (
    <PreservedLink
      to="/"
      className="flex items-center space-x-2 py-2"
      onClick={handleLogoClick}
    >
      <img
        src={logoSrc}
        alt="Claims1"
        className="h-12 w-auto transition-opacity hover:opacity-80 md:h-14"
      />
    </PreservedLink>
  )
}

export default Logo
